module.exports = __webpack_public_path__ + "img/ditie.fe59ed6a.png";